import { Tabs } from "@amzn/awsui-components-react";
import * as React from "react";
import RecommendationsSection from "./recommendations-tab/RecommendationsSection";
import { CalcBusterItem } from "../calcBusterTypes";
import GeneralSection from "./general-tab/GeneralSection";
import ModernizationSection from "./modernization-tab/Modernization";
import MAPSection from "./map-tab/MAPSection";

const ReportTabs: React.FC<{ item: CalcBusterItem }> = ({ item }) => {
  const annualRunRate = item["annualRunRate"];
  const modernizations = item["modernizations"] ?? {};
  const funding = item["funding"] ?? {};
  const recommendations = item["recommendations"] ?? [];
  const services = item["services"] ?? [];
  return (
    // more tabs to come
    <Tabs
      tabs={[
        {
          label: "General",
          id: "general_tab",
          content: GeneralSection(funding, modernizations, services),
        },
        {
          label: "Modernization",
          id: "modernization_tab",
          content: ModernizationSection(modernizations, services),
        },
        {
          label: "Recommendations",
          id: "recommendations_tab",
          content: (
            <RecommendationsSection
              recommendations={recommendations}
              annualRunRate={annualRunRate}
            />
          ),
        },
        {
          label: "Migration Acceleration Program (MAP)",
          id: "map_tab",
          content: (
            <MAPSection
              funding={funding}
              modernizations={modernizations}
              services={services}
            />
          ),
        },
      ]}
      variant="container"
    />
  );
};

export default ReportTabs;
